var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    staticClass: "ws-dialogue",
    attrs: {
      "width": "500"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.userInfo !== null,
            expression: "userInfo !== null"
          }],
          staticClass: "ws-btn ma-0 px-4 py-5",
          attrs: {
            "id": "add-workspace",
            "block": "",
            "color": "grey darken-3",
            "dark": !!_vm.userInfo,
            "depressed": "",
            "large": ""
          }
        }, on), [_vm._v(" New Workspace "), _c('v-spacer'), _c('v-icon', {
          attrs: {
            "right": "",
            "dark": "",
            "size": "20px"
          }
        }, [_vm._v(" mdi-plus-circle ")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline pb-0 pt-3",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(" Create Workspace ")]), _c('v-card-text', {
    staticClass: "px-4 pt-4 pb-1"
  }, [_c('v-text-field', {
    attrs: {
      "id": "workspace-name",
      "autofocus": "",
      "dense": "",
      "outlined": "",
      "label": "Workspace name",
      "error-messages": _vm.error ? [_vm.error] : []
    },
    model: {
      value: _vm.newWorkspace,
      callback: function ($$v) {
        _vm.newWorkspace = $$v;
      },
      expression: "newWorkspace"
    }
  })], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-4 py-3"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "id": "create-workspace",
      "color": "grey darken-3",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v(" Create Workspace ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }